import cn from "classnames";
import Heading from "../../components/heading/Heading";
import React, { FC, useState } from "react";
import ActivityCard from "./components/activityCard/ActivityCard";
import st from './activities.module.scss';
import { activities, activityTabs, ActivityTypes } from "@pages/partners/items/uralchem/static/sectionsData";

interface ActivitiesProps {
    className: string
}

const Activities: FC<ActivitiesProps> = ({className}) => {

    const [selectedActivityId, setSelectedActivityId] = useState<keyof typeof ActivityTypes>('soil');

    return (
        <section className={cn(className, st['activities'])}>
            <Heading.Section>Направления деятельности</Heading.Section>
            <div className={st['activities__wrapper']}>
                <div className={st['activities__tab-list']}>
                    {activityTabs.map(({id, label}) => (
                        <div
                            className={cn(
                                st['activities__tab'],
                                (selectedActivityId === id) && st['activities__tab--selected'],
                            )}
                            onClick={() => setSelectedActivityId(id)}
                            btn-text={label}
                        >
                            {label}
                        </div>
                    ))}
                </div>
                <ActivityCard {...activities[selectedActivityId]}/>
            </div>
        </section>
    );
};

export default Activities;